import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { twMerge } from 'tailwind-merge';
import { inputClasses } from './TextInput';
interface SelectInputProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  options: {
    value: string;
    label: string;
    disabled?: boolean;
  }[];
}
export function SelectInput({
  options,
  className,
  ...rest
}: SelectInputProps) {
  return <div className="relative" data-id="element-487" data-mp="15hrlpg6asa25">
      <select className={twMerge(inputClasses, 'h-10 appearance-none border-line-strong pr-9', className)} {...rest} data-id="element-488" data-mp="15ikhxn7mrh61">
        {options.map(option => <option key={option.value} value={option.value} disabled={option.disabled} data-id="element-489" data-mp="1egmn8eyecvz4">
            {option.label}
          </option>)}
      </select>
      <ChevronDownIcon className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-ink-soft" aria-hidden="true" data-id="element-490" data-mp="mqrppv0dxzzd" />
    </div>;
}